<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <!-- begin: เลขที่เอกสาร -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">เลขที่เอกสาร:</label>
                  <span class="form-control-plaintext">{{ ubpDocNo }}</span>
                </div>
              </div>
              <!-- end: เลขที่เอกสาร -->

              <!-- begin: ผู้ขอเบิก/ยืม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">ผู้ขอเบิก/ยืม:</label>
                  <select2
                    :disabled="true"
                    :css-style="'width: 100%;'"
                    :css-class="'form-control required'"
                    :id="'ubpBorrower'"
                    :name="'ubpBorrower'"
                    :select2-options="ubpBorrowerOptions"
                    v-model="ubpBorrower"
                    @selectChange="ubpBorrowerChange"
                    ref="ubpBorrowerSelect2"
                    data-msg-required="กรุณาเลือกผู้ขอเบิก/ยืม"
                  ></select2>
                  <span class="form-text"></span>
                  <!-- <span class="form-control-plaintext">{{ ubpBorrower }}</span> -->
                </div>
              </div>
              <!-- end: ผู้ขอเบิก/ยืม -->

              <!-- begin: ตัวแทนจำหน่าย/หน่วย -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย/หน่วยงาน:</label>
                  <select2
                    :disabled="true"
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'ubpAgentCode'"
                    :name="'ubpAgentCode'"
                    :select2-options="ubpAgentOptions"
                    v-model="ubpAgentCode"
                    @selectChange="onAgentCodeChange"
                    ref="ubpAgentSelect2"
                  ></select2>
                  <span class="form-text"></span>
                  <!-- <span class="form-control-plaintext">{{ ubpAgentCode }}</span> -->
                </div>
              </div>
              <!-- end: ตัวแทนจำหน่าย/หน่วย -->

              <!-- begin: ชื่อ-สกุลผู้รับสินค้าแทน -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อ-สกุลผู้รับสินค้าแทน:</label>
                  <input
                    :disabled="true"
                    id="ubpRepresentName"
                    name="ubpRepresentName"
                    v-model="ubpRepresentName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                  />
                  <!-- <span class="form-control-plaintext">{{ ubpRepresentName }}</span> -->
                </div>
              </div>
              <!-- end: ชื่อ-สกุลผู้รับสินค้าแทน -->

              <!-- begin: เบอร์โทรผู้รับสินค้าแทน -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">เบอร์โทรผู้รับสินค้าแทน:</label>
                  <input
                    :disabled="true"
                    id="ubpRepresentTel"
                    name="ubpRepresentTel"
                    v-model="ubpRepresentTel"
                    type="text"
                    maxlength="450"
                    class="form-control"
                  />
                  <!-- <span class="form-control-plaintext">{{ ubpRepresentTel }}</span> -->
                </div>
              </div>
              <!-- end: เบอร์โทรผู้รับสินค้าแทน -->

              <!-- Begin:วันที่เอกสาร input -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">วันที่เอกสาร :</label>
                  <span class="form-control-plaintext">{{ ubpReqDate }}</span>
                </div>
              </div>
              <!-- End:วันที่เอกสาร input -->

              <!-- Begin:ประเภทใบคำร้องขอ input -->
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="col-3 col-form-label label-required"
                    >ประเภทใบคำร้องขอ:</label
                  >
                  <div class="col-9">
                    <div class="kt-checkbox-inline">
                      <label
                        class="kt-checkbox"
                        v-for="(ubpRequestTypeOption,
                        ubp) in ubpRequestTypeOptions"
                        :key="ubp"
                      >
                        <input
                          type="checkbox"
                          :id="ubpRequestTypeOption.id"
                          :value="ubpRequestTypeOption.id"
                          checked
                          v-model="ubpRequestType"
                          :disabled="true"
                        />
                        {{ ubpRequestTypeOption.text }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End:ประเภทใบคำร้องขอ input -->

              <!-- Begin:หมวดหมู่สินค้า input -->
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="col-3 col-form-label label-required"
                    >หมวดหมู่สินค้า:</label
                  >
                  <div class="col-9">
                    <div class="kt-radio-inline">
                      <label
                        class="kt-radio rea"
                        v-for="(ubpProductGroupOption,
                        index) in ubpProductGroupOptions"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :id="ubpProductGroupOption.id"
                          :value="ubpProductGroupOption.id"
                          v-model="ubpProductGroup"
                          @change="onProductGroupChange($event)"
                          :disabled="true"
                        />
                        {{ ubpProductGroupOption.text }}
                        <span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End:หมวดหมู่สินค้า input -->

              <!-- Begin: table -->
              <div id="Activity" class="col-xl-12 table-responsive table-checkable">
                <table class="table table-sm table-striped table-bordered table-hover" style="min-width:2250px;">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 1%;">ลำดับ</th>
                      <th class="text-center" style="width: 6%;">สถานะ</th>
                      <th class="text-center" style="width: 8%;">
                        ประเภทสินค้า
                      </th>
                      <th class="text-center" style="width: 13%;">
                        ชื่อสินค้า
                      </th>
                      <th class="text-center" style="width: 6%;">
                        รูปภาพ
                      </th>
                      <th class="text-center" style="width: 6%;">
                        โควต้า(แบรนด์)
                      </th>
                      <th class="text-center" style="width: 5%;">จำนวน</th>
                      <th class="text-center" style="width: 15%;">
                        ตัวแทนจำหน่าย
                      </th>
                      <th class="text-center" style="width: 18%;">
                        ชื่อร้านค้า/กิจกรรม
                      </th>
                      <th class="text-center" style="width: 12%;">
                          หมายเหตุกิจกรรม
                          <i class="far fa-copy"
                             style="cursor: pointer; margin-left: 5px;transform: scaleX(-1);color: #5867dd;"
                             @click="copyNote" title='คัดลอกข้อความ "หมายเหตุกิจกรรม" ของแถวที่1'></i>
                      </th>
                      <th class="text-center" style="min-width: 160px !important">
                        วันที่กำหนดคืน
                      </th>
                      <th class="text-center" style="width: 2%;">การจัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="plItems == null || plItems.length == 0">
                      <td colspan="11" class="text-muted text-center">
                        คลิก + เพื่อเพิ่มรายการใหม่
                      </td>
                    </tr>
                    <template v-for="(item, i) in plItems">
                      <pl-item-row
                        ref="plItems"
                        :key="i"
                        :rowIndex="i"
                        :item="item"
                        :isEditable="ubpIsEdit"
                        @removeItem="onRemoveItemClick(i, item)"
                      ></pl-item-row>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="5" style="text-align:right;">
                        จำนวนรวมมูลค่าการเบิกยืม (บาท)
                      </th>
                      <th style="text-align:center;">
                        {{ totalCal | currency("฿", 2) }}
                      </th>
                    </tr>
                    <tr>
                      <td colspan="11">
                        <button
                          type="button"
                          class="btn btn-sm btn-brand"
                          @click.prevent="onAddItemClick"
                        >
                          <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <!-- End: table -->
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>หมายเหตุ:</label>
                  <textarea
                    placeholder="หมายเหตุ"
                    class="form-control"
                    v-model="ubpRemark"
                    rows="5"
                  ></textarea>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <h4 class="kt-section__title">ประวัติการอนุมัติ</h4>
                <!-- Begin: table -->
                <div class="row">
                  <div class="col-lg-12 table-responsive">
                    <table
                      class="table-sm table-striped- table-bordered table-hover table-checkable"
                      id="table-history"
                    >
                      <thead>
                        <tr>
                          <th>วันที่</th>
                          <th>ผู้อนุมัติ</th>
                          <th>ลำดับ</th>
                          <th>สถานะ</th>
                          <th>หมายเหตุ</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
                <!-- End: table -->
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.push({ path: `/Borrow` })"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <!-- <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>-->
          <!-- <button
            type="button"
            class="btn btn-success"
            @click="onSendForApprove()"
            v-if="ubpStatusCode === 'PRODUCT_LOAN_STATUS_SAVED'"
          >
            <i class="flaticon-paper-plane-1"></i> ส่งขออนุมัติ
          </button>-->
          <button
            type="button"
            class="btn btn-success"
            @click="onApprove($event)"
            v-if="ubpIsApprove === true"
          >
            <i class="la la-check"></i> อนุมัติ
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="onReject($event)"
            v-if="ubpIsApprove === true"
          >
            <i class="la la-close"></i> ไม่อนุมัติ
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import plItemRow from "./ProductLoanItemRow";

export default {
  components: {
    select2,
    datepicker,
    plItemRow,
  },
  data: function() {
    var self = this;

    return {
      isChange: false,
      plItems: [],
      plApproveHistoryItems: [],
      plItemsTemp: [],
      i: 0,
      ubpDocNo: null,
      ubpProductLoanId: null,
      ubpBorrower: null,
      ubpAgentCode: null,
      ubpRepresentName: null,
      ubpRepresentTel: null,
      ubpReqDate: null,
      ubpRequestType: [],
      ubpRequestTypeOptions: [],
      ubpProductGroup: null,
      ubpProductGroupId: null,
      ubpProductGroupOptions: [],
      ubpRemark: null,
      ubpIsAgent: false,
      ubpIsApprove: false,
      ubpStatusCode: null,
      ubpIsEdit: false,

      /* begin: Set Select2 Options*/
      ubpAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgentOrg",
          data: function(params) {
            var query = {
              userId: self.ubpBorrower,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      ubpBorrowerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductLoan/Select2Borrower",
          data: function(params) {
            var query = {
              userId: "",
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      /* end: Set Select2 Options*/
    };
  },

  methods: {
    onAddItemClick(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      this.plItems.push({
        plProductLoanItemId: null,
        plStatus: null,
        plProductId: null,
        plProductType: null,
        plQuota: null,
        plQty: 0,
        plPrice: 0,
        plAvgPrice: 0,
        plInitialPrice: 0,
        plAgent: null,
        plShopId: null,
        plShopActivityId: null,
        plActivityId: null,
        plIsShop: false,
        plActivityIdRemark: null,
        plReturnDate: null,
        plAvailableQty: 0,
        plStatusCode: null,
        selectedStatusCodeData: null,
        selectedProductData: null,
        selectedProductTypeData: null,
        selectedQuotaData: null,
        selectedAgentData: null,
        selectedShopData: null,
        selectedActivityData: null,
      });
    },
    onRemoveItemClick(index, delItem) {
      var self = this;
      self.plItemsTemp = self.plItems;
      self.plItems = [];
      self.plItemsTemp.splice(index, 1);
      self.isChange = false;
      /*=== Binding items=== */
      setTimeout(function() {
        self.plItems = self.plItemsTemp;

        setTimeout(function() {
          for (let i = 0; i < self.plItems.length; i++) {
            /*=== Check Is Shop & Set Selected Select2=== */
            if (
              (self.plItems[i].plShopId === null &&
                self.plItems[i].plActivityId === null) ||
              self.plItems[i].plShopActivityId === null
            ) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
                id: "0",
                text: "ไม่ระบุ",
              });
            } else if (self.plItems[i].plActivityId != null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
                self.plItems[i].selectedActivityData
              );
            } else {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
                self.plItems[i].selectedShopData
              );
            }

            /*=== Check Is Agent & Set Selected Select2=== */
            if (self.plItems[i].plAgent === null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                id: "0",
                text: "ไม่ระบุ",
              });
            }
            if (self.plItems[i].plAgent !== null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData(
                self.plItems[i].selectedAgentData
              );
            }

            /*=== Status : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plStatus.setSelectedData(
              self.plItems[i].selectedStatusCodeData
            );

            /*=== ProductId : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductId.setSelectedData(
              self.plItems[i].selectedProductData
            );
            /*=== ProductType : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductType.setSelectedData(
              self.plItems[i].selectedProductTypeData
            );

            /*=== Quota : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plQuota.setSelectedData(
              self.plItems[i].selectedQuotaData
            );

            /*=== Set DatePicker ReturnDate=== */
            if (self.plItems[i].plReturnDate != null) {
              $(self.$refs.plItems[i].$refs.plReturnDate).datepicker(
                "update",
                self.plItems[i].plReturnDate.format("DD/MM/YYYY")
              );
            }
          }
        }, 50);

        // setTimeout(function() {
        //   for (let i = 0; i < self.plItems.length; i++) {
        //     /*=== Check Is Shop & Set Selected Select2=== */
        //     if (
        //       (self.plItems[i].plShopId === null &&
        //         self.plItems[i].plActivityId === null) ||
        //       self.plItems[i].plShopActivityId === null
        //     ) {
        //       self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
        //         id: "0",
        //         text: "ไม่ระบุ"
        //       });
        //     } else if (self.plItems[i].plActivityId != null) {
        //       self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
        //         self.plItems[i].selectedActivityData
        //       );
        //     } else {
        //       self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
        //         self.plItems[i].selectedShopData
        //       );
        //     }

        //     /*=== Check Is Agent & Set Selected Select2=== */
        //     if (self.plItems[i].plAgent === null) {
        //       self.$refs.plItems[i].$refs.plAgent.setSelectedData({
        //         id: "0",
        //         text: "ไม่ระบุ"
        //       });
        //     }
        //     if (self.plItems[i].plAgent !== null) {
        //       self.$refs.plItems[i].$refs.plAgent.setSelectedData(
        //         self.plItems[i].selectedAgentData
        //       );
        //     }

        //     /*=== Status : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plStatus.setSelectedData(
        //       self.plItems[i].selectedStatusCodeData
        //     );

        //     /*=== ProductId : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plProductId.setSelectedData(
        //       self.plItems[i].selectedProductData
        //     );
        //     /*=== ProductType : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plProductType.setSelectedData(
        //       self.plItems[i].selectedProductTypeData
        //     );

        //     /*=== Quota : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plQuota.setSelectedData(
        //       self.plItems[i].selectedQuotaData
        //     );

        //     /*=== Set DatePicker ReturnDate=== */
        //     if (self.plItems[i].plReturnDate != null) {
        //       $(self.$refs.plItems[i].$refs.plReturnDate).datepicker(
        //         "update",
        //         self.plItems[i].plReturnDate.format("DD/MM/YYYY")
        //       );
        //     }
        //   }
        // }, 50);
      }, 50);
    },
    formSubmit: function() {
      //e.preventDefault();

      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var pItems = [];

      self.plItems.forEach((element) => {
        pItems.push({
          ProductLoanItemId: element.plProductLoanItemId,
          Status: element.plStatus,
          ProductId: element.plProductId,
          ProductType: element.plProductType,
          AgentCode: element.plAgent,
          QuotaId: element.plQuota,
          Qty: element.plQty,
          Price: element.plPrice,
          ShopId: element.plShopId,
          ActivityId: element.plActivityId,
          IsShop: element.plIsShop,
          Remark: element.plActivityRemark,
          ReturnDate:
            element.plReturnDate != null
              ? element.plReturnDate.format("DD/MM/YYYY")
              : null,
        });
      });

      axios({
        method: "put",
        url: "/Api/ProductLoan",
        data: {
          productLoanId: self.ubpProductLoanId,
          agentCode: self.ubpAgentCode,
          borrower: self.ubpBorrower,
          representName: self.ubpRepresentName,
          RepresentTel: self.ubpRepresentTel,
          requestDate: self.ubpReqDate,
          requestType: self.ubpRequestType,
          productGroupId: self.ubpProductGroup,
          amount: self.ubpAmount,
          isAgent: self.ubpIsAgent,
          productLoanItems: pItems,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            // Swal.fire("สำเร็จ", response.data.message, "success").then(
            //   function() {
            //     router.go(-1), self.$parent.reloadDataTable(false);
            //   }
            // );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onAgentCodeChange: function(id, text, data, ref) {
      var self = this;
      if (text !== "") {
        self.ubpIsAgent = data[0].data.agent;
      }
    },
    onProductGroupChange: function() {
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        this.ubpProductGroupId = "1";
      }
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        this.ubpProductGroupId = "2";
      }
    },
    ubpBorrowerChange: function(id, text, data, ref) {
      var self = this;
      if (this.isChange) {
        $("#ubpAgentCode")
          .val("")
          .trigger("change");
      }

      setTimeout(function() {
        self.ubpProductGroupOptions = [];
        axios
          .get("/Api/Variables/ProductLoanProductGroupOptions", {
            params: {
              userId: self.ubpBorrower,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              if (
                response.data.results != null &&
                response.data.results.length > 0
              ) {
                for (let i = 0; i < response.data.results.length; i++) {
                  self.ubpProductGroupOptions.push({
                    id: response.data.results[i].id,
                    text: response.data.results[i].text,
                  });
                }
              }
            } else {
              Swal.fire(
                "เกิดข้อผิดพลาด",
                "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
                "warning"
              );
              router.go(-1);
            }
          })
          .catch(function(error) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
              "error"
            );
            router.go(-1);
          })
          .then(function() {
            // always executed
            KTApp.unblockPage();
          });
      }, 10);
    },
    onRequestTypeChange: function(e) {},
    onSendForApprove: function(e) {
      let router = this.$router;
      let self = this;
      axios
        .get("/Api/ProductLoan/" + this.$route.params.id + "/SendForApprove")
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          //router.go(-1);
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onApprove: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;

      console.log(self.plItems.length);

      //Validate form
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      Swal.fire({
        title: "คำสั่งอนุมัติการเบิก/ยืม",
        type: "warning",
        html: "กรุณายืนยันอนุมัติการเบิก/ยืม <strong>",
        inputValue: 0,
        inputPlaceholder: "อนุมัติการเบิก/ยืม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then(async (result) => {

        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังอนุมัติข้อมูล กรุณารอสักครู่...",
          });

          //UpdateBorrowProduct
          if (self.ubpIsEdit) {
            //self.formSubmit();
            var pItems = [];
            // self.plItems.forEach(element => {
            //   pItems.push({
            //     ProductLoanItemId: element.plProductLoanItemId,
            //     Status: element.plStatus,
            //     ProductId: element.plProductId,
            //     ProductType: element.plProductType,
            //     AgentCode: element.plAgent,
            //     QuotaId: element.plQuota,
            //     Qty: element.plQty,
            //     Price: element.plPrice,
            //     ShopId: element.plShopId,
            //     ActivityId: element.plActivityId,
            //     IsShop: element.plIsShop,
            //     Remark: element.plActivityRemark,
            //     ReturnDate:element.plReturnDate != null
            //         ? element.plReturnDate.format("DD/MM/YYYY")
            //         : null
            //   });
            // });

            for (let i = 0; i < self.plItems.length; i++) {
              let element = self.plItems[i];
              pItems.push({
                Index: i + 1,
                ProductLoanItemId: element.plProductLoanItemId,
                Status: element.plStatus,
                ProductId: element.plProductId,
                ProductType: element.plProductType,
                AgentCode: element.plAgent,
                QuotaId: element.plQuota,
                Qty: element.plQty,
                Price: element.plPrice,
                ShopId: element.plShopId,
                ActivityId: element.plActivityId,
                IsShop: element.plIsShop,
                Remark: element.plActivityRemark,
                ReturnDate:
                  element.plReturnDate != null
                    ? element.plReturnDate.format("DD/MM/YYYY")
                    : null,
              });
            }

            // AXIOS POST STEP 1 HARE
            await new Promise(resolve => {
              axios({
                method: "put",
                url: "/Api/ProductLoan",
                data: {
                  productLoanId: self.ubpProductLoanId,
                  agentCode: self.ubpAgentCode,
                  borrower: self.ubpBorrower,
                  representName: self.ubpRepresentName,
                  RepresentTel: self.ubpRepresentTel,
                  requestDate: self.ubpReqDate,
                  requestType: self.ubpRequestType,
                  productGroupId: self.ubpProductGroup,
                  amount: self.ubpAmount,
                  isAgent: self.ubpIsAgent,
                  productLoanItems: pItems,
                  remark: self.ubpRemark,
                },
              })
                .then(function(response) {
                  if (response.data.status) {
                    resolve('resolved');
                    // Swal.fire("สำเร็จ", response.data.message, "success").then(
                    //   function() {
                    //     router.go(-1), self.$parent.reloadDataTable(false);
                    //   }
                    // );
                  } else {
                    Swal.fire(
                      "เกิดข้อผิดพลาด",
                      error.response.data.message,
                      "error"
                    );
                  }
                })
                .catch(function(error) {
                  Swal.fire(
                    "เกิดข้อผิดพลาด",
                    error.response.data.message,
                    "error"
                  );
                  KTApp.unblockPage();
                })
                .then(function() {
                  // always executed
                  //KTApp.unblockPage();
                });
            });
          }

          // AXIOS POST STEP 2 HARE
          await new Promise(resolve => {
            axios.get("/Api/ProductLoan/" + this.$route.params.id + "/Approve")
              .then(function(response) {
                if (response.data.status) {
                  resolve('resolved');
                  Swal.fire("สำเร็จ", response.data.message, "success").then(
                    function() {
                      //router.go(-1), self.$parent.reloadDataTable(false);
                      router.push({ path: `/Borrow` });
                      self.$parent.reloadDataTable(false);
                    }
                  );
                } else {
                  Swal.fire(
                    "เกิดข้อผิดพลาด",
                    error.response.data.message,
                    "error"
                  );
                }
              })
              .catch(function(error) {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
              })
              .then(function() {
                // always executed
                KTApp.unblockPage();
              });
          });
        }
      });
    },
    onReject: function(e) {
      e.preventDefault();
      let self = this;
      let router = this.$router;
      Swal.fire({
        title: "คำสั่งไม่อนุมัติเบิกคลังสินค้า",
        type: "warning",
        html: "กรุณายืนยันไม่อนุมัติเบิกคลังสินค้า <strong>",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        // inputValue: 0,
        inputPlaceholder: "กรุณาระบุหมายเหตุผลไม่อนุมัติเบิกคลังสินค้า",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value === "") {
              resolve("กรุณาระบุหมายเหตุผลไม่อนุมัติเบิกคลังสินค้า");
            } else {
              resolve();
            }
          });
        },
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });
          axios({
            method: "post",
            url: "/Api/ProductLoan/Reject",
            data: {
              Id: this.$route.params.id,
              Remark: result.value,
            },
          })
            // .post("/Api/ProductLoan/" + this.$route.params.id + "/Reject",)
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function() {
                    //router.go(-1), self.$parent.reloadDataTable(false);
                    router.push({ path: `/Borrow` });
                    self.$parent.reloadDataTable(false);
                  }
                );
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        } else {
        }
      });
     },
      copyNote() {
          Swal.fire({
              title: "คำสั่งแก้ไข หมายเหตุกิจกรรม",
              type: "warning",
              html: "กรุณายืนยันคำสั่งคัดลอกแก้ไข หมายเหตุกิจกรรม ทั้งหมดตามข้อมูลแถวที่ 1",
              showCancelButton: true,
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
              showLoaderOnConfirm: true,
          }).then((result) => {

              if (result.value) {
                  var self = this;
                  // Start copy comment
                  if (self.plItems != null && self.plItems.length > 0) {
                      // copy activityRemark from 1st row.
                      let activityRemarkRow1 = self.plItems[0].plActivityRemark;

                      for (let i = 1; i < self.plItems.length; i++) {
                          //self.plItems[i].plActivityRemark = activityRemarkRow1;
                          self.$set(self.plItems[i], 'plActivityRemark', activityRemarkRow1);

                      }
                  }
              }
          });
      }
  },
  computed: {
    totalCal() {
      let self = this;
      var totalSum = 0;
      if (self.plItems != null && self.plItems.length > 0) {
        for (let i = 0; i < self.plItems.length; i++) {
          if (self.plItems[i].plInitialPrice != 0) {
            totalSum += Number(
              self.plItems[i].plQty * self.plItems[i].plInitialPrice
            );
            self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          } else {
            totalSum += Number(
              self.plItems[i].plQty * self.plItems[i].plAvgPrice
            );
            self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          }

          // if (self.plItems[i].plAvgPrice != 0) {
          //   totalSum += Number(
          //     self.plItems[i].plQty * self.plItems[i].plAvgPrice
          //   );
          //   self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          // } else {
          //   totalSum += Number(
          //     self.plItems[i].plQty * self.plItems[i].plInitialPrice
          //   );
          //   self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          // }
          self.ubpAmount = totalSum;
        }
      }
      return totalSum;
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.ubpReqDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      //startDate: moment().format("DD/MM/YYYY"), //Current day
      //endDate: moment().format("DD/MM/YYYY"), //Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.ubpReqDate = moment();
    $(self.$refs.ubpReqDate)
      .datepicker("update", self.ubpReqDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.ubpReqDate = moment(e.date);
      });

    //Begin :Get Value RequestType CheckBox
    axios
      .get("/Api/Variables/Options", {
        params: {
          search: "PRODUCT_LOAN_REQUEST_TYPE",
        },
      })
      .then(function(response) {
        if (response.status == 200) {
          if (
            response.data.results != null &&
            response.data.results.length > 0
          ) {
            for (let i = 0; i < response.data.results.length; i++) {
              self.ubpRequestTypeOptions.push({
                id: response.data.results[i].id,
                text: response.data.results[i].text,
              });
            }
          }
          return self.ubpRequestTypeOptions;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    //End :Get Value RequestType CheckBox

    //Begin :Get Value ProductGroup Radio checkbox
    // axios
    //   .get("/Api/Variables/Options", {
    //     params: {
    //       search: "PRODUCT_LOAN_PRODUCT_GROUP"
    //     }
    //   })
    //   .then(function(response) {
    //     if (response.status == 200) {
    //       if (
    //         response.data.results != null &&
    //         response.data.results.length > 0
    //       ) {
    //         for (let i = 0; i < response.data.results.length; i++) {
    //           self.ubpProductGroupOptions.push({
    //             id: response.data.results[i].id,
    //             text: response.data.results[i].text
    //           });
    //         }
    //       }
    //     } else {
    //       Swal.fire(
    //         "เกิดข้อผิดพลาด",
    //         "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
    //         "warning"
    //       );
    //       router.go(-1);
    //     }
    //   })
    //   .catch(function(error) {
    //     Swal.fire(
    //       "เกิดข้อผิดพลาด",
    //       "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
    //       "error"
    //     );
    //     router.go(-1);
    //   })
    //   .then(function() {
    //     // always executed
    //     KTApp.unblockPage();
    //   });
    //End :Get Value ProductGroup Radio checkbox

    axios
      .get("/Api/ProductLoan/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null) {
            self.ubpProductLoanId = response.data.productLoanHeaderId;
            self.ubpDocNo = response.data.requestDocNo;
            self.ubpRepresentName = response.data.representativeName;
            self.ubpRepresentTel = response.data.representativeNameL;
            self.ubpStatusCode = response.data.productLoanStatusCode;
            self.ubpIsApprove = response.data.isApprove;
            self.ubpIsEdit = response.data.isEdit;
            self.ubpBorrower = response.data.requestUser;
            if (response.data.requestUserId) {
              self.$refs.ubpBorrowerSelect2.setSelectedData({
                id: response.data.requestUserId,
                text: response.data.requestUser,
              });
            }
            // self.ubpAgentCode = response.data.agentOrgName;
            setTimeout(() => {
              if (response.data.agentOrgCode) {
                self.$refs.ubpAgentSelect2.setSelectedData({
                  id: response.data.agentOrgCode,
                  text: response.data.agentOrgName,
                  data: {
                    agent: response.data.isAgent,
                    org: !response.data.isAgent,
                    id: response.data.agentOrgCode,
                  },
                });
              }
            }, 50);
            self.ubpReqDate = response.data.requestDateFormat;

            self.ubpIsAgent = response.data.isAgent;
            self.ubpRequestType = response.data.requestTypeList;
            self.ubpProductGroup = response.data.productGroupId;
            if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
              self.ubpProductGroupId = "1";
            }
            if (
              self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS"
            ) {
              self.ubpProductGroupId = "2";
            }

            self.ubpRemark = response.data.remark;
            self.ubpAmount = response.data.amount;
            if (response.data.productLoanItem.length > 0) {
              for (let i = 0; i < response.data.productLoanItem.length; i++) {
                var item = response.data.productLoanItem[i];
                self.plItems.push({
                  plProductId: item.materialCode,
                  plProductType: item.productTypeId,
                  plProductLoanItemId: item.productLoanItemId,
                  plStatus: item.statusCode,
                  selectedStatusCodeData: {
                    id: item.statusCode,
                    text: item.statusName,
                    data: null,
                  },
                  selectedProductData: {
                    id: item.materialCode,
                    text: item.materialName + " [" + item.materialCode + "]",
                    data: item.productData,
                  },
                  selectedProductTypeData: {
                    id: item.productTypeId,
                    text: item.productTypeName,
                    data: null,
                  },
                  plQuota: item.quotaId,
                  selectedQuotaData: {
                    id: item.quotaId,
                    text: item.quotaName,
                    data: null,
                  },
                  plAgent: item.agentCode,
                  selectedAgentData: {
                    id: item.agentCode,
                    text: "[" + item.agentCode + "] " + item.agentCodeName,
                    data: null,
                  },
                  plShopId: item.shopId,
                  selectedShopData: {
                    id: item.shopId,
                    text: item.shopName,
                    data: null,
                  },
                  plActivityId: item.activityId,
                  selectedActivityData: {
                    id: item.activityId,
                    text: item.activityName,
                  },
                  plQty: item.qty, //Stamp Qty
                  plAvailableQty: item.productData.availableQTY, //Current Qty
                  plPrice: 0, //Stamp Price
                  plAvgPrice: item.productData.avgPrice, //Current avgPrice
                  plInitialPrice: item.productData.initialPrice, //Current initialPrice
                  plIsShop: item.shopId != null ? true : false,
                  plShopActivityId: "",
                  plActivityRemark: item.activityRemark,
                  plReturnDate:
                    item.returnDateFormat != null
                      ? moment(item.returnDateFormat, "DD/MM/YYYY")
                      : null,
                });
                setTimeout(function() {
                  /*=== Status : Set Selected Select2=== */
                  self.$refs.plItems[i].$refs.plStatus.setSelectedData(
                    self.plItems[i].selectedStatusCodeData
                  );
                  /*=== ProductType : Set Selected Select2=== */
                  self.$refs.plItems[i].$refs.plProductType.setSelectedData(
                    self.plItems[i].selectedProductTypeData
                  );
                  setTimeout(function() {
                    /*=== ProductId : Set Selected Select2=== */
                    self.$refs.plItems[i].$refs.plProductId.setSelectedData(
                      self.plItems[i].selectedProductData
                    );
                  }, 100);
                  /*=== Quota : Set Selected Select2=== */
                  self.$refs.plItems[i].$refs.plQuota.setSelectedData(
                    self.plItems[i].selectedQuotaData
                  );
                  /*=== Check Is Agent & Set Selected Select2=== */
                  if (self.plItems[i].plAgent === null) {
                    self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                      id: "0",
                      text: "ไม่ระบุ",
                    });
                  } else if (self.plItems[i].plAgent !== null) {
                    self.$refs.plItems[i].$refs.plAgent.setSelectedData(
                      self.plItems[i].selectedAgentData
                    );
                  }
                  setTimeout(function() {
                    /*=== Set Selected Select2 ShopActivity=== */
                    if (self.plItems[i].plShopActivityId == "") {
                      /*=== Set Selected Select2 ShopActivity is "ไม่ระบุ"=== */
                      if (
                        self.plItems[i].plShopId === null &&
                        self.plItems[i].plActivityId === null
                      ) {
                        self.plItems[i].plShopActivityId = "0";
                        self.$refs.plItems[
                          i
                        ].$refs.plShopActivityId.setSelectedData({
                          id: "0",
                          text: "ไม่ระบุ",
                        });
                      }
                      //=== Set Selected Select2 ShopActivity is "Activity"===//
                      else if (self.plItems[i].plActivityId != null) {
                        self.plItems[i].plShopActivityId =
                          self.plItems[i].plActivityId;
                        self.$refs.plItems[
                          i
                        ].$refs.plShopActivityId.setSelectedData(
                          self.plItems[i].selectedActivityData
                        );
                      }
                      //=== Set Selected Select2 ShopActivity is "Shop"===//
                      else {
                        self.plItems[i].plShopActivityId =
                          self.plItems[i].plShopId;
                        self.$refs.plItems[
                          i
                        ].$refs.plShopActivityId.setSelectedData(
                          self.plItems[i].selectedShopData
                        );
                      }
                    }
                  }, 100);
                  /*=== set datepicker returnDate === */
                  if (self.plItems[i].plReturnDate != null) {
                    $(self.$refs.plItems[i].$refs.plReturnDate).datepicker(
                      "update",
                      self.plItems[i].plReturnDate.format("DD/MM/YYYY")
                    );
                  }
                  self.isChange = true;
                }, 300);
              }
            }
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed

        KTApp.unblockPage();
      });

    var table = $("#table-history");

    // begin first table
    table
      .DataTable({
        responsive: true,
        // processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/ProductLoan/ApproveHistorySearch",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              ProductLoanId: self.$route.params.id,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12'tr>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[2, "desc"]],
        select: {
          style: "multi",
          selector: "td:first-child",
        },
        columns: [
          { data: "createdDateFormat", className: "text-center" },
          { data: "approveUser", className: "text-center" },
          { data: "approveLevel", className: "text-center" },
          { data: "approveStatus", className: "text-center" },
          { data: "remark", className: "text-center" },
        ],
      })
      .on("draw.dt", function() {});
    // table.trigger("draw.dt"); //call ajax delete this row

    // set validation rules
    $(self.$refs.form).validate({
      rules: {
        ubpAgentCode: "required",
        ubpBorrower: "required",
        ubpRequestDate: "required",
        ubpRequestType: "required",
        ubpProductGroup: "required",
      },
      messages: {
        ubpAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        ubpBorrower: "กรุณากรอกผู้ขอเบิก/ยืม",
        ubpRequestDate: "กรุณากรอกวันที่",
        ubpRequestType: "กรุณาเลือกประเภทใบคำร้องขอ",
        ubpProductGroup: "กรุณาเลือกหมวดหมู่สินค้า",
      },
    });
  },
};
</script>

<style>
td {
  font-size: 14.5px !important;
}
.input-group-append > .input-group-text, td.form-group > input[type=number],
td > .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
@media print {
  @page {
    size: A4 landscape;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 15px;
    margin-right: 15px;
  }
  body {
    transform: scale(0.73) !important;
    transform-origin: top left !important;
    min-width: 2250px !important;
    overflow-y: scroll !important;
  }
}
</style>


// WEBPACK FOOTER //
// App/Components/Borrow/DetialBorrowProduct.vue